
import {getAbout,getCarouselImage,getServiceList,getTalentRecruitment,reqPartnerInfo} from '@/api/home'
const state = {
   
    carouselImage:[],
    serveList:[],
    serveListTotal:-1,
    aboutContent:{},
    aboutList:[],
    talent_recruitment:[],
    partnerInfo:[]
}
const mutations = {
 
    GETCAROUSELIMAGE(state,value){
        state.carouselImage = value
        state.count = Number(value.length)
    },

    GETSERVICELIST(state,value){
        if(state.serveList.length!=state.serveListTotal) {
            value.records.forEach(element => {
                state.serveList.push(element)
            });
        }
        
        state.serveListTotal = value.total
       
    },
    GETABOUT(state,value){
        // console.log(value,666)
        state.aboutContent = value
        state.aboutList = JSON.parse(value.attr)
    },
    CLEAR(state){
        state.serveList=[]
    },
    GETTALENTRECRUITMENT(state,value){
        state.talent_recruitment = value
    },
    GETPARTNERINFO(state,value){
        state.partnerInfo = value
    }
}
const actions = {
   

    async getCarouselImage({commit}){
        let res =await getCarouselImage()
        if(res.code == 200){
            commit('GETCAROUSELIMAGE',res.data.picture.split(','))
        }
    },
    
    async getServiceList({commit},data){
        let res =await getServiceList(data.pageNum,data.pageSize)
        if(res.code == 200){
            commit('GETSERVICELIST',res.data)
        }
    },
    async getAbout({commit}){
        let res = await getAbout()
        if(res.code == 200){
            commit('GETABOUT',res.data)
        }
    },
    async getTalentRecruitment({commit}){
        let res = await getTalentRecruitment()
        if(res.code == 200){
            commit('GETTALENTRECRUITMENT',res.data)
        }
    },
    async getPartner({commit}){
        let res = await reqPartnerInfo()
        if(res.code == 200){
            commit('GETPARTNERINFO',res.data)
        }
    },
    clear({commit}){
        commit('CLEAR')
    }



}
const getters = {}
export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
}